<template>
  <v-dialog v-model="isOpen"
            width="auto"
            :persistent="options_.persistent"
            :min-width="options_.minWidth"
            @keydown.esc="cancel">
    <v-card>
      <v-toolbar dark
                 :color="options_.color"
                 dense
                 flat>
        <v-toolbar-title :class="options_.class">{{ options_.title }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text v-show="!!options_.message"
                   class="pa-4 py-8">
        <slot>
          <div v-html="options_.message"></div>
        </slot>
      </v-card-text>
      <v-card-actions class="pt-0">
        <v-spacer></v-spacer>
        <v-btn @click="cancel">{{ options_.secondaryActionLabel }}</v-btn>
        <v-btn color="primary"
               variant="tonal"
               :loading="loading"
               @click="agree">{{ options_.primaryActionLabel }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">

export interface DialogOptions {
  title?: string;
  message?: string;
  color?: string;
  minWidth?: number;
  class?: string;
  primaryActionLabel?: string;
  secondaryActionLabel?: string;
  /**
   * Persistent dialogs are not dismissed when touching outside or pressing the esc key.
   **/
  persistent?: boolean;
}

const defaultOptions: DialogOptions = {
  title: 'Confirm',
  message: 'You sure?',
  color: 'primary',
  minWidth: 420,
  class: 'text-white',
  primaryActionLabel: 'OK',
  secondaryActionLabel: 'Cancel',
  persistent: false,
};

export type ConfirmFunction = () => Promise<boolean> | boolean;

export interface Props {
  options?: DialogOptions;
  onConfirm: ConfirmFunction;
  onCancel?: Function;
}

const props = defineProps<Props>();
const isOpen = defineModel<boolean>({ default: false });
const loading = ref(false);

const options_ = computed(() => {
  return {
    ...defaultOptions,
    ...props.options
  };
});

function agree() {
  const result = props.onConfirm();
  if (result instanceof Promise) {
    loading.value = true;
    result.then((res) => {
      loading.value = false;
      if (res) {
        isOpen.value = false;
      }
    });
  } else if (result) {
    isOpen.value = false;
  }
}

function cancel() {
  if (props.onCancel)
    props.onCancel();
  isOpen.value = false;
}

</script>


<style scoped lang="scss"></style>